<template>
    <div></div>
</template>

<script>
    export default {
        name: "PageNotFound",

        created() {
            window.location.href = "/404";
        }
    }
</script>

<style scoped>

</style>
